module.exports = __webpack_public_path__ + "static/media/download-primary.0ca08c1a.svg";